<template>
<div>
    <Header />
    <main>
        <div v-if="isLoading" class="loader-overlay">
            <div class="spinner-border text-light" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <section class="position-relative overflow-hidden pt-xl-8">
            <div class="position-absolute start-0 top-0">
                <img src="assets/images/elements/grad-shape/blur-decoration-2.svg" class="opacity-1 blur-9 h-300px rotate-335" alt="Grad shape" />
            </div>

            <div class="position-absolute end-0 top-0">
                <img src="assets/images/elements/grad-shape/blur-decoration-2.svg" class="opacity-1 blur-8 h-300px rotate-335" alt="Grad shape" />
            </div>
            <div class="container position-relative pt-4 pt-sm-5">
                <div class="row">
                    <div class="col-lg-8 mx-auto text-center mb-4 mb-sm-6">
                        <a href="#" class="badge text-bg-dark mb-4">{{ article.category }}</a>
                        <h1 class="h2 mb-0">{{ article.title }}</h1>
                    </div>
                    <div class="col-12 mx-auto text-center mb-4 mb-sm-6">
                        <img :src="BACK_URL + article.cover" class="img-fluid rounded" :alt="article.title" />
                    </div>
                    <div class="col-md-11 mx-auto mb-4 mb-sm-6">
                        <div class="row">
                            <div class="col-md-4 text-center mb-6 mb-md-0">
                                <div class="avatar avatar-xxl mx-auto flex-shrink-0 mb-3">
                                    <img class="avatar-img rounded-circle" src="/assets/images/logovisennia.svg" alt="visennia" />
                                </div>
                                <p class="mb-1 opacity-6">By</p>
                                <h6 class="mb-3"> {{ article.user_name }}</h6>

                                <div class="d-flex justify-content-center align-items-center flex-wrap">
                                    <div class="dropdown">
                                        <a href="#" class="text-primary-hover" id="cardFeedAction" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="bi bi-share me-2"></i> Share
                                        </a>
                                        <ul class="dropdown-menu" aria-labelledby="cardFeedAction">
                                            <li>
                                                <a class="dropdown-item" href="#" @click="shareOnFacebook">
                                                    <i class="bi bi-facebook me-2"></i> Facebook
                                                </a>
                                            </li>
                                            <li>
                                                <a class="dropdown-item" href="#" @click="shareOnTwitter">
                                                    <i class="bi bi-twitter me-2"></i> Twitter
                                                </a>
                                            </li>
                                            <li>
                                                <a class="dropdown-item" href="#" @click="shareOnLinkedIn">
                                                    <i class="bi bi-linkedin me-2"></i> LinkedIn
                                                </a>
                                            </li>
                                            <li>
                                                <a class="dropdown-item" href="#" @click="shareOnWhatsApp">
                                                    <i class="bi bi-whatsapp me-2"></i> WhatsApp
                                                </a>
                                            </li>
                                            <li>
                                                <a class="dropdown-item" href="#" @click="copyArticleUrl">
                                                    <i class="bi bi-clipboard me-2"></i> Copy URL
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>

                            <div class="col-md-7 ms-auto">
                                <p>
                                    <span class="dropcap heading-color bg-secondary bg-opacity-50 rounded px-2">
                                        {{ getFirstLetterOfContent(article.content) }}
                                    </span>
                                    <span v-html="getContentWithoutFirstLetter(article.content)"></span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-10 mx-auto mb-4 mb-sm-6">
                        <blockquote class="card card-body bg-secondary bg-opacity-50 overflow-hidden p-sm-5 mb-5 position-relative text-center">
                            <span class="display-4 text-primary position-absolute top-0 start-0 mt-n3"><i class="bi bi-quote"></i></span>
                            <q class="fs-6 heading-color m-0 d-block">Actions speak louder than words.</q>
                        </blockquote>

                        <div class="bg-secondary bg-opacity-50 rounded d-md-flex justify-content-between align-items-center text-center px-4 py-3">
                            <h6 class="mb-0">Was this article helpful?</h6>
                            <small class="py-3 p-md-0 d-block"># out of #found this helpful</small>
                            <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
                                <input type="radio" class="btn-check" name="btnradio" id="btnradio1">
                                <label class="btn btn-outline-primary btn-sm mb-0" for="btnradio1"><i class="bi bi-hand-thumbs-up"></i> Yes</label>
                                <input type="radio" class="btn-check" name="btnradio" id="btnradio2">
                                <label class="btn btn-outline-primary btn-sm mb-0" for="btnradio2"> No <i class="bi bi-hand-thumbs-down"></i></label>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-10 mx-auto mb-4">
                        <hr class="mb-4 mb-sm-6">
                        <h5>{{ comments.length }} comments</h5>

                        <div v-for="comment in comments" :key="comment.id" class="my-2 d-flex">
                            <img class="avatar avatar-sm rounded-circle me-2" src="/assets/images/user.avif" alt="avatar">
                            <div>
                                <div class="mb-1">
                                    <h6 class="m-0 fs-6">{{ comment.name }}</h6>
                                    <span class="me-2 small">{{ comment.created_at }}</span>
                                </div>
                                <p class="mb-1 fs-7">{{ comment.content }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-10 mx-auto">
                        <div class="bg-secondary bg-opacity-50 rounded-4 p-4 p-sm-5">
                            <h5 class="mb-0">Your Views Please!</h5>
                            <small>Your email address will not be published. Required fields are marked *</small>
                            <form @submit.prevent="submitComment" class="row g-3 mt-2">
                                <div class="col-lg-12">
                                    <label class="form-label">Name *</label>
                                    <input v-model="comment.name" type="text" class="form-control" required />
                                </div>

                                <div class="col-12">
                                    <label class="form-label">Your Comment *</label>
                                    <textarea v-model="comment.content" class="form-control" rows="3" required></textarea>
                                </div>

                                <div class="col-12">
                                    <button type="submit" class="btn btn-primary mb-0">Comment</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <BlogSlider />
    </main>
    <Footer />
</div>
</template>

    
    
<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import BlogSlider from '@/components/BlogSlider.vue';
import axios from "@/api/axios.js";
import {
    BACK_URL
} from "@/article_cover.js";

export default {
    components: {
        Header,
        Footer,
        BlogSlider
    },
    data() {
        return {
            article: {},
            comments: {},
            BACK_URL,
            comment: {
                name: '',
                content: ''
            },
            isLoading: true,
        };
    },
    mounted() {
        this.fetchArticleDetails();
    },
    methods: {
        async fetchArticleDetails() {
            const articleId = this.$route.params.id;
            try {
                const response = await axios.get(`/show-article/${articleId}`);
                this.article = response.data;
                this.comments = this.article.commentaires;
            } catch (error) {
                console.error('Error fetching article details:', error);
            } finally {
                this.isLoading = false;
            }
        },

        async submitComment() {
            const formData = new FormData();
            formData.append('name', this.comment.name);
            formData.append('content', this.comment.content);
            formData.append('article_id', this.$route.params.id);

            try {
                const response = await axios.post('/add-commentaires', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                });
                console.log('Comment added:', response.data);

                this.comment.name = '';
                this.comment.content = '';
            } catch (error) {
                console.error('Error submitting comment:', error);
            }
        },

        getFirstLetterOfContent(content) {
            if (content) {
                const strippedContent = content.replace(/<[^>]*>/g, '');
                return strippedContent.charAt(0).toUpperCase();
            }
            return '';
        },

        getContentWithoutFirstLetter(content) {
            if (content) {
                const strippedContent = content.replace(/<[^>]*>/g, '');
                return content.replace(strippedContent.charAt(0), '');
            }
            return '';
        },

        shareOnFacebook() {
            const url = `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`;
            window.open(url, '_blank');
        },

        shareOnTwitter() {
            const url = `https://twitter.com/intent/tweet?url=${window.location.href}`;
            window.open(url, '_blank');
        },

        shareOnLinkedIn() {
            const url = `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}`;
            window.open(url, '_blank');
        },

        shareOnWhatsApp() {
            const url = `https://wa.me/?text=${window.location.href}`;
            window.open(url, '_blank');
        },

        copyArticleUrl() {
            navigator.clipboard.writeText(window.location.href).then(() => {
                alert('URL copied to clipboard');
            }).catch(err => {
                console.error('Failed to copy URL: ', err);
            });
        }
    }
};
</script>

<style scoped>
.loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
</style>
